import { Component, OnDestroy, OnInit } from '@angular/core';
import { IPackageDto, OdabirPaketaDto, PackageDto, PaketiClient, SubscriptionPackage } from '@kodit/core/data-api';
import { Subscription } from 'rxjs';
import { OdabirPaketaService } from '../odabir-paketa.service';
import { PackageEventResult } from '../odabir-paketa/package-box/package-box.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import { DialogSize } from '../../../../../shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { UsloviUgovoraDialogComponent } from './uslovi-ugovora-dialog/uslovi-ugovora-dialog.component';

@Component({
  selector: 'kodit-odabir-paketa-form2',
  templateUrl: './odabir-paketa-form2.component.html',
  styleUrls: ['./odabir-paketa-form2.component.scss'],
})
export class OdabirPaketaForm2Component implements OnInit, OnDestroy {
  private _subs: Subscription;

  PackageType = SubscriptionPackage;
  packages: PackageDto[] = [];
  disabledMainPackages: Set<SubscriptionPackage> = new Set();
  freeSeatsCount: number = 0;
  isLoading = true;
  jeNadogradnja: boolean = false;
  shouldHideYearlySwitch: boolean = false;
  isYearly: boolean = true;
  zastupnici: string | undefined;

  /** Dialog */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);

  constructor(
    private paketiClient: PaketiClient,
    public service: OdabirPaketaService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _alert: AlertService,
    private _dialogService: DynamicDialogService
  ) {
    this._subs = new Subscription();
    this.service.getForm();
    this.jeNadogradnja = this._route.snapshot.data.isNadogradnja;
  }

  ngOnInit(): void {
    this._subs.add(
      this.service.getIsYearlyObservable.subscribe((res) => {
        this.isYearly = res;
      })
    );
    this._loadPackage();
    if (this.jeNadogradnja) {
      this._subs.add(
        this.paketiClient.getUserPackages().subscribe((res) => {
          this.service.patchForm(res.data!.paketi);
          this.shouldHideYearlySwitch = res.data.paketi.isYearly;
          this.zastupnici = res.data.zastupnici;
          this.freeSeatsCount = this.service.getFreeSeats();
        })
      );
    }
  }

  private _loadPackage(): void {
    this._subs.add(
      this.paketiClient.getAll().subscribe({
        next: (res) => {
          this.packages = res.data ?? [];
          this.updatePackageAvailability();
          this.isLoading = false;
        },
      })
    );
  }

  // ako je main paket treba da enable sve additions
  handlePackageSelected(event: PackageEventResult) {
    const selectedPackage = this.packages.find(
      (p) =>
        p.packageId === event.packageId && p.packageType === event.packageType
    );

    switch (selectedPackage.packageType) {
      case SubscriptionPackage.EFAKTURE:
      case SubscriptionPackage.VELEPRODAJA:
        this.service.handlePackageSelect(
          selectedPackage,
          event.incrementNumber
        );
        // automatski dodajemo efakture api
        this.service.handlePackageSelect(
          this.packages.find(
            (p) => p.packageType === SubscriptionPackage.EFAKTURE_API
          )
        );
        break;

      case SubscriptionPackage.FISKALNA_KASA:
      case SubscriptionPackage.MALOPRODAJA:
        this.service.handlePackageSelect(
          selectedPackage,
          event.incrementNumber
        );
        // automatski dodajemo fiskalna api
        this.service.handlePackageSelect(
          this.packages.find(
            (p) => p.packageType === SubscriptionPackage.FISKLANI_API
          )
        );
        break;

      default:
        this.service.handlePackageSelect(
          selectedPackage,
          event.incrementNumber
        );
        break;
    }

    this.updatePackageAvailability();
    this.freeSeatsCount = this.service.getFreeSeats();
  }

  handlePackageUnselected(event: PackageEventResult) {
    const unselectedPackage = this.packages.find(
      (x) => x.packageType === event.packageType
    );
    this.service.handlePackageUnselect(
      unselectedPackage,
      event.incrementNumber
    );
    this.updatePackageAvailability();
    this.freeSeatsCount = this.service.getFreeSeats();
  }

  // metoda koja azurira isDisabled polja
  updatePackageAvailability() {
    this.disabledMainPackages = this.service.getDisabledMainPackages();
  }

  getLabel(type: SubscriptionPackage): string {
    return this.packages.find((p) => p.packageType === type)?.label ?? '';
  }

  getPrice(type: SubscriptionPackage): number {
    return this.packages.find((p) => p.packageType === type)?.price ?? 0;
  }

  getPriceLabel(type: SubscriptionPackage): string {
    return this.packages.find((p) => p.packageType === type)?.priceLabel ?? '';
  }

  getPackageId(type: SubscriptionPackage): string | undefined {
    return this.packages.find((p) => p.packageType === type)?.packageId;
  }

  // getTotalPrice(): number {
  //   const packages: IPackageDto[] = this.service.getPackagesForFixedTotal;
  //   const popust = 0.9; // 10%;
  //
  //   let total = 0;
  //
  //   packages.forEach((pkg) => {
  //     total += pkg.price ?? 0;
  //   });
  //
  //   // godisnja pretplataa
  //   if (this.service.getForm().controls.isYearly.value) {
  //     total = total * 12 * popust;
  //   }
  //
  //   return total;
  // }

  getMonthlyPrice() {
    let total = 0;
    this.service.getPackagesForFixedTotal
      .filter((x) => x.priceLabel.includes('mesečno'))
      .forEach((p) => {
        total += p.price;
      });
    return total;
  }

  // Vraca vrednost samo za godisnje pakete
  getOnlyYearlyPrice() {
    let total = 0;
    this.service.getPackagesForFixedTotal
      .filter((x) => x.priceLabel.includes('godišnje'))
      .forEach((p) => {
        total += p.price;
      });

    return total;
  }

  getYearlyPrice() {
    const popust = 0.9;
    let total = this.getMonthlyPrice() * 12 * popust;

    // Godisnje pakete ne mnozimo sa 12
    total += this.getOnlyYearlyPrice() * popust;

    return total;
  }

  // ako je paket selektovan, tj. ako je dodat u form za registraciju onda vracamo true
  // ovo nam je potrebno kako bi vracanjem na prvi korak imali prikaz izabranih paketa
  isPackageSelected(packageType: SubscriptionPackage): boolean {
    return this.service.getPackages.value.some(
      (p: IPackageDto) => p.packageType === packageType
    );
  }

  openUsloviDialog() {
    if (this.service.getForm().value.packages.length === 0) {
      this._alert.addWarnMsg('Potrebno je odabrati bar jedan paket!');
      return;
    }

    this.dialogConfig.header = 'Potvrda uslova ugovora';
    this.dialogConfig.hideFooter = true;
    this.dialogConfig.data = {
      paketi: this.service.getForm().value as OdabirPaketaDto,
      zastupnici: this.zastupnici,
    };

    const ref = this._dialogService.open(
      UsloviUgovoraDialogComponent,
      this.dialogConfig
    );

    this._subs.add(
      ref.onClose.subscribe((res) => {
        if (res) {
          this._router.navigate(['/dashboard']).then();
        }
      })
    );
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
